import React, { useEffect, useRef, useState } from 'react';
import validator from 'validator';

import { TextField } from '@mui/material';

import Styles from '../lib/Styles';
import classes from './SelectField.module.scss';

export default function SelectURL(props: any) {
  const {selectedURL, setSelectedURL, urlError, setURLError, onChangeURL, readOnly } = props;
  let initialValue = useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  const [lengthURL, setLengthURL] = useState<number>(selectedURL ? selectedURL.length : 0);
  const [showHelper, setShowHelper] = useState<boolean>(false);
  const maxNumberOfCharacters: number = 500;

  useEffect(() => {
    if (initialValue.current) {
      setLengthURL(initialValue.current.length);
      setSelectedURL(initialValue.current);
      initialValue.current = undefined;
    }
  }, [setSelectedURL])

  // Prevent entry of Enter key and Space key.
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (('Enter' === event.key)) {// || ' ' === event.key) {
       event.preventDefault();
     }
  };

  // This will get triggered on any key press except for Enter and Space.
  const handleURLChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    let lengthValue = value.length;
    if (lengthValue > maxNumberOfCharacters) {
      value = value.substr(0, maxNumberOfCharacters);
    }
    setLengthURL(value.length);
    setSelectedURL(value);
    if (value === '' || validator.isURL(value, {require_protocol: true})) {
      setURLError(false)
    }
    onChangeURL();
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    let value = event.target.value;
    if (value === '') {
      setURLError(false);
      setShowHelper(false);
    } else {
      let isValidURL = validator.isURL(value, {require_protocol: true});
      setURLError(!isValidURL);
      if (isValidURL) {
        setShowHelper(false);
      }
    }
  }

  const helperText = () => {
    let text = '';
    if (showHelper) {
      if (urlError) {
        text = 'Invalid URL Format';
      } else {
        text = (maxNumberOfCharacters - lengthURL).toLocaleString() +  ' characters left';
      }
    }
    return text;
  }

  return (
    <form className={cx('root')} noValidate autoComplete="off">
      <div>
        <TextField
          disabled={readOnly}
          error={urlError}
          label="Campaign URL"
          helperText={helperText()}
          multiline
          defaultValue={undefined}
          inputProps={{
            readOnly: readOnly
          }}
          variant="outlined"
          value={selectedURL}
          onInput={handleURLChange}
          onFocus={() => setShowHelper(true)}
          onBlur={handleBlur}
          placeholder="Enter URL here."
          onKeyPress={handleKeyPress}
          required={false}
        />
      </div>
    </form>
  );
}